module.exports = __webpack_public_path__ + "static/media/beginners.e4eb0bb4.png";